<template>
  <div class="w-full lg:flex lg:flex-row">
    <div class="w-full mx-auto">
      <div class="w-full px-10 pt-3 pb-3 seccion">
        <div class="w-full seccion">
          <div
            class="flex justify-between py-2 text-xs font-bold border-b border-gray-200"
          >
            <div class="hidden uppercase">{{ $t("Paso 2 de 3") }}</div>
            <div class="hidden text-red-600 red">
              <a
                target="_blank"
                :href="`/${$i18n.locale}/contenido/condiciones`"
              >
                {{ $t("Leer condiciones") }}
              </a>
            </div>
          </div>
        </div>
        <h2 class="text-2xl font-bold tracking-tight text-left">
          {{ $t("Modificar Establecimiento") }}
        </h2>

        <div class="text-left">
          <span v-if="!editarActual.BONOS">
            {{
              $t(
                "Si estás dado de alta, puedes modificar tu establecimiento aquí"
              )
            }}
          </span>
          <span v-if="editarActual.BONOS">
            {{ $t("Establecimientos ya dados de alta") }}
          </span>
        </div>
      </div>
      <div class="w-full px-10 pt-3 bg-white seccion">
        <div v-if="mostrarFormulario">
          <VForm
            v-if="$t('activar_altas') == 'S'"
            class="flex flex-wrap text-left styled"
            @submit.prevent="onSubmit"
          >
            <template #default="form">
              <div
                class="w-full px-2 md:w-1/2 xl:w-1/3"
                :class="`${isMultiple[item.campo] ? ' hidden' : ' visible'}`"
                v-for="(item, i) in camposComprobar"
                :key="i"
              >
                <VInput
                  v-if="item.visible"
                  class="text-xs font-bold uppercase"
                  :class="`${
                    item.obligatorio ? ' obligatorio' : 'no-obligatorio'
                  }`"
                  v-model="establecimientoActual[item.campo]"
                  :type="item.tipo"
                  :label="$t(item.texto)"
                  :name="item.campo"
                  :required="item.obligatorio"
                  :minlength="item.min"
                  :maxlength="item.max"
                  :options="item.tipo == 'select' ? listado[item.campo] : []"
                  :multiple="
                    isMultiple[item.campo] ? isMultiple[item.campo] : false
                  "
                >
                  <template #description="input">
                    <template v-if="input.error">
                      <small v-if="input.invalid.required">{{
                        $t("Campo obligatorio")
                      }}</small>
                      <small v-if="input.invalid.minlength">
                        {{ $t("mínimo") }} {{ item.min }} {{ $t("caracteres") }}
                      </small>
                      <small v-if="input.invalid.maxlength">
                        {{ $t("max") }} {{ item.max }} {{ $t("caracteres") }}
                      </small>
                    </template>
                  </template>
                </VInput>
                <!-- <pre>
                {{form.inputs[item.campo]}}
              </pre> -->
              </div>
              <div v-if="form.valid" class="w-full py-4 mb-10 seccion">
                <button
                  class="block w-full my-3 font-bold text-white uppercase bg-green-600 hover:bg-green-700"
                  type="submit"
                >
                  {{ $t("Enviar") }}
                </button>
              </div>
            </template>
          </VForm>
        </div>

        <div v-if="editarActual.NOMBRE" class="w-full">
          <div v-for="actual in filtroBonos" :key="actual" class="w-full">
            <div class="grid gap-2 my-2 md:grid-cols-2 lg:grid-cols-3">
              <button
                :disabled="campanasActivas[item.ID]"
                @click="comprobarCompleto(item)"
                v-for="item in campanas[actual]"
                :key="item.ID"
                :class="`${
                  !campanasActivas[item.ID] ? 'bg-green-100' : 'bg-white'
                }`"
                class="p-2 overflow-hidden text-xs text-left text-gray-800"
              >
                <h3 class="text-sm font-medium leading-6 text-gray-900">
                  {{ item.NOMBRE }}({{ item.ID }})
                </h3>
                <p>{{ item.DIRECCION }}</p>
                <p>{{ item.CP }} {{ item.POBLACION }} / {{ item.PROVINCIA }}</p>
                <p>{{ item.DESCRIPCION }}</p>
                <p
                  class="w-20 p-1 my-2 font-bold text-center text-white bg-green-700 rounded"
                  v-if="!campanasActivas[item.ID]"
                >
                  {{ $t("Añadir") }}
                </p>
                <p
                  class="w-20 p-1 my-2 font-bold text-center text-white bg-red-700 rounded"
                  v-if="campanasActivas[item.ID]"
                >
                  {{ $t("Consultar") }}
                </p>
              </button>
            </div>
          </div>
        </div>
        <p ref="ficha" class="w-full my-5 border-b border-gray-100"></p>
        <div v-if="editarActual.BONOS" class="w-full">
          <div class="w-full">
            <div
              class="flex flex-col-reverse w-full px-4 py-5 mx-auto bg-gray-100 border-b border-gray-200 sm:px-6 md:flex-row md:flex"
            >
              <div class="flex-grow">
                <h3 class="mt-2 text-lg font-medium leading-6 text-gray-900">
                  {{ editarActual.NOMBRE }} - {{ editarActual.ID }}
                </h3>
                <p
                  class="max-w-2xl mt-1 text-sm leading-5 text-gray-600 font-base"
                >
                  {{ editarActual.DESCRIPCION }}
                </p>
                <p
                  class="max-w-2xl mt-1 text-sm leading-5 text-gray-800 font-base"
                >
                  {{ editarActual.DIRECCION }}
                </p>
                <p
                  class="max-w-2xl mt-1 text-sm leading-5 text-gray-600 font-base"
                >
                  {{ editarActual.EMAIL }}
                </p>
                <p
                  class="max-w-2xl mt-1 text-sm leading-5 text-gray-600 font-base"
                >
                  {{ editarActual.TELEFONO }}
                </p>

                <p
                  class="max-w-2xl mt-1 text-sm leading-5 text-gray-600 font-base"
                >
                  {{ editarActual.POBLACION }} / {{ editarActual.PROVINCIA }}
                </p>

                <!-- <div class="max-w-2xl mt-10 mb-5 text-sm leading-5 text-gray-600 font-base">
                <p class="font-bold text-blue-800 fecha"> ALTA: 27 de octubre de 2020 12:44 </p>
                <p class="font-bold text-blue-800 fecha"> Modificacion: 27 de octubre de 2020 13:44 </p>
              </div> -->
                <!-- <p>
                <button
                  @click="cambiarCorto(editarActual)"
                  class="px-3 py-1 my-5 font-bold bg-gray-200 btn btn-blue "
                > {{('Certificado')}} </button>
              </p> -->
                <!-- <div class="w-full">
                <p><button class="btn">guardar</button></p>
              </div> -->
              </div>
              <div class="">
                <div
                  class="w-64 h-64 bg-gray-300 bg-center bg-no-repeat bg-cover"
                  :style="`background-image: url('${getImagen(editarActual)}')`"
                ></div>
              </div>
            </div>
            <div class="w-full px-1" v-if="editarActual.BONOS && !editable">
              <div
                class="flex flex-col max-w-screen-sm mt-2 text-xs font-bold leading-4 text-blue-800"
              >
                {{ $t("Bonos") }}: <br />
                <span
                  v-for="item in datosCompleto.BONOS"
                  :key="item.NOMBREBONO"
                  class="p-1 ml-1"
                >
                  {{ item.NOMBREBONO }}
                </span>
              </div>
              <div
                class="max-w-screen-sm mt-2 text-xs font-bold leading-5 text-blue-800"
              >
                {{ $t("Sector Actividad") }}: <br />
                <span
                  v-for="item in datosCompleto.SECTORES"
                  :key="item.IDSECTOREACTIVIDAD"
                  class="p-1 ml-1 bg-white rounded-full shadow-xs"
                >
                  {{ item.NOMBRE }} ..
                </span>
              </div>
              <div
                class="max-w-screen-sm mt-2 text-xs font-bold leading-5 text-blue-800"
              >
                {{ $t("IAE") }}: <br />
                <span
                  v-for="item in datosCompleto.IAES"
                  :key="item.IAE"
                  class="p-1 ml-1 bg-white rounded-full shadow-xs"
                >
                  {{ item.IAE }}
                </span>
              </div>
            </div>
          </div>

          <!-- <pre v-if="editarActual">
              {{editarActual}}
            </pre> -->

          <div v-if="editable" class="w-full">
            <!-- MULti select  -->
            <div class="w-full px-2 py-2">
              <div class="text-xs font-bold uppercase obligatorio">
                <span class="vts-input__text"> {{ $t("IAE") }} </span>
              </div>
              <multiselect
                v-model="IAE"
                name="IAE"
                :options="listado.IAE"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="false"
                selectLabel="+"
                deselectLabel="-"
                selectedLabel=""
                @select="accionCambio('IAE')"
                @remove="accionCambio('IAE')"
                placeholder=""
                label="label"
                track-by="value"
              >
                <span slot="noResult">--</span>
              </multiselect>
            </div>

            <div class="w-full px-2 py-2">
              <div class="text-xs font-bold uppercase obligatorio">
                <span class="vts-input__text">
                  {{ $t("Sector de actividad") }}
                </span>
              </div>
              <multiselect
                v-model="SectorActividad"
                name="SectorActividad"
                :options="listado.SectorActividad"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="false"
                selectLabel="+"
                deselectLabel="-"
                selectedLabel=""
                @select="accionCambio('SectorActividad')"
                @remove="accionCambio('SectorActividad')"
                placeholder=""
                label="label"
                track-by="value"
              >
                <span slot="noResult">--</span>
              </multiselect>
            </div>

            <div class="w-full px-2 py-2">
              <div class="text-xs font-bold uppercase obligatorio">
                <span class="vts-input__text"> {{ $t("Tipo de Bonos") }} </span>
              </div>
              <multiselect
                v-model="TipoBono"
                name="TipoBono"
                :options="listado.TipoBono"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="false"
                selectLabel="+"
                deselectLabel="-"
                selectedLabel=""
                @select="accionCambio('TipoBono')"
                @remove="accionCambio('TipoBono')"
                placeholder=""
                label="label"
                track-by="value"
              >
                <span slot="noResult">--</span>
              </multiselect>
            </div>
            <div class="hidden w-full p-2">
              <VDrawer
                v-model="ventanaCertificado"
                transition="slide-right"
                bg-transition="fade"
                :classes="{ bg: 'bg-blue-900', content: 'bg-gray-200' }"
              >
                <template #toggle="{ bind, on }">
                  <button
                    class="w-full h-20 px-3 py-5 text-sm bg-gray-200 bold hover:bg-gray-400"
                    v-bind="bind"
                    v-on="on"
                  >
                    {{ $t("Adjuntar certificado titularidad de cuenta (pdf)") }}
                  </button>
                </template>
                <div class="w-full p-5">
                  <div class="text-base font-semibold text-blue-900">
                    {{ $t("Adjuntar certificado titularidad de cuenta (pdf)") }}
                  </div>
                  <div class="text-xs">(max 3M)</div>
                  <upload-imagen
                    carpeta="establecimientos/berriz"
                    tipo="imagen-certificado"
                    :imageId="Id"
                    nombre="UrlCertificado"
                    accept="*"
                    :max="6650000"
                    ventana="ventanaCertificado"
                    @cerrar="cerrarVentana"
                  ></upload-imagen>
                  <div class="w-full my-3">
                    <button
                      class="text-sm"
                      @click.prevent="ventanaCertificado = !ventanaCertificado"
                    >
                      {{ $t("Cerrar") }}
                    </button>
                  </div>
                </div>
              </VDrawer>
              <div class="px-2 imagenes">
                <div class="text-xs">
                  <div class="text-red-700 bold" v-if="!UrlCertificado">
                    {{ $t("falta imagen") }}
                  </div>
                  <div class="text-green-500" v-else>
                    {{ $t("imagen subida correctamente") }}
                  </div>
                </div>
                <VInput
                  class="text-xs font-bold uppercase opacity-0"
                  v-model="establecimientoActual['UrlCertificado']"
                  type="text"
                  label="url"
                  name="UrlCertificado"
                  minlength="2"
                >
                  <template #description="input">
                    <template v-if="input.error">
                      <small v-if="input.invalid.required">{{
                        $t("Campo obligatorio")
                      }}</small>
                      <small v-if="input.invalid.minlength">
                        {{ $t("mínimo") }} {{ item.min }} {{ $t("caracteres") }}
                      </small>
                    </template>
                  </template>
                </VInput>
              </div>
            </div>

            <div class="w-full my-5 text-xs font-thin text-red-600">
              <p v-for="(t, i) in validador2" :key="i">
                <span>
                  {{ $t(t.texto) }}
                </span>
              </p>
              <!-- <p v-for="i in validosIAE" :key="i.value">
                <span> IAE: {{ $t(i.texto) }} </span>
              </p> -->
              <!-- <p v-for="s in validosSector" :key="s.SECTORACTIVIDAD">
                <span>
                  {{ $t("SECTORACTIVIDAD") }}: {{ $t(s.SECTORACTIVIDAD) }}
                </span>
              </p> -->
              <p v-for="i in masCampos" :key="i.campo">
                <span v-if="!establecimientoActual[i.campo]">
                  {{ $t(i.texto) }}
                </span>
              </p>
            </div>
            <!-- <pre>
              {{ misBonos }} {{ validosIAE }}
            </pre> -->

            <div v-if="camposValidados" class="w-full">
              <div
                v-html="$t('declaración responsable')"
                class="w-full p-5 text-xs bg-gray-100"
              ></div>
            </div>
            <div v-if="camposValidados" class="w-full py-4 mb-10 seccion">
              <div class="my-3 condiciones">
                <v-input
                  v-model="Aceptar"
                  class="flex text-xs font-thin"
                  :label="$t('Acepto Condiciones')"
                  name="checkbox"
                  type="checkbox"
                  required
                >
                  <template #description="input">
                    <template v-if="input.error">
                      <small v-if="input.invalid.required">{{
                        $t("Acepta Condicinoes")
                      }}</small>
                    </template>
                  </template>
                </v-input>
                <div class="mt-2 text-xs text-right text-red-700">
                  <a
                    target="_blank"
                    :href="`/${$i18n.locale}/contenido/condiciones`"
                  >
                    {{ $t("Leer condiciones") }}
                  </a>
                </div>
              </div>

              <button
                :disabled="!Aceptar"
                :class="`${
                  !Aceptar ? 'bg-gray-300' : 'bg-green-600 hover:bg-green-700'
                }`"
                class="block w-full my-3 font-bold text-white uppercase"
                @click="enviarCambios"
              >
                {{ $t("Enviar") }}
              </button>
            </div>
          </div>
        </div>

        <div class="w-full py-5 text-base lg:text-sm">
          <h3 class="font-bold">
            {{ $t("Consultas") }}
          </h3>
          <p>{{ $t("email") }}: {{ $t("correo@contacto") }}</p>

          <p>{{ $t("teléfono") }} {{ $t("telefono@contacto") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import slugify from "slugify";
import { VForm, VInput, VDrawer, VDialog } from "vuetensils/src/components";
import {
  SectorActividad_es,
  SectorActividad_eu,
  Municipios,
  IAE_ES,
  IAE_EU,
  Bonos_es,
  Bonos_eu,
  IAE_TURISMO,
  IAE_TURISMO_EU,
  Distritos,
} from "@/assets/datos.json";
import Multiselect from "vue-multiselect";
import uploadImagen from "@/components/core/Uploader.vue";
import SubirImagen from "@/components/Cropper";
// GoogleMaps
import gmapsInit from "@/config/pro/gmaps";

function fn_ValidateIBAN(IBAN) {
  //Se pasa a Mayusculas
  IBAN = IBAN.toUpperCase();
  //Se quita los blancos de principio y final.
  IBAN = IBAN.trim();
  IBAN = IBAN.replace(/\s/g, ""); //Y se quita los espacios en blanco dentro de la cadena

  var letra1, letra2, num1, num2;
  var isbanaux;
  var numeroSustitucion;
  //La longitud debe ser siempre de 24 caracteres
  if (IBAN.length != 24) {
    return false;
  }

  // Se coge las primeras dos letras y se pasan a números
  letra1 = IBAN.substring(0, 1);
  letra2 = IBAN.substring(1, 2);
  num1 = getnumIBAN(letra1);
  num2 = getnumIBAN(letra2);
  //Se sustituye las letras por números.
  isbanaux = String(num1) + String(num2) + IBAN.substring(2);
  // Se mueve los 6 primeros caracteres al final de la cadena.
  isbanaux = isbanaux.substring(6) + isbanaux.substring(0, 6);

  //Se calcula el resto, llamando a la función modulo97, definida más abajo
  var resto = modulo97(isbanaux);
  if (resto == 1) {
    return true;
  } else {
    return false;
  }
}

function modulo97(iban) {
  var parts = Math.ceil(iban.length / 7);
  var remainer = "";

  for (var i = 1; i <= parts; i++) {
    remainer = String(parseFloat(remainer + iban.substr((i - 1) * 7, 7)) % 97);
  }

  return remainer;
}

function getnumIBAN(letra) {
  const ls_letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  return ls_letras.search(letra) + 10;
}

export default {
  components: {
    VForm,
    VInput,
    uploadImagen,
    VDrawer,
    VDialog,
    SubirImagen,
    Multiselect,
  },
  mounted() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    this.$store.dispatch("getBono", "bizkaia");
    this.mensaje = "";
    this.Aceptar = false;
    // console.log("montado", this.establecimientoActual);
  },
  data() {
    return {
      IdBarrio: {},
      ruta: "bizkaia",
      mensaje: "",
      editable: false,
      campanas: {},
      origenFiltro: 12,
      origenDestino: 7,
      campanaDestino: 7,
      filtroBonos: [12],
      mostrarFormulario: true,
      editarActual: {},
      datosCompleto: {},
      ventanaComercio: false,
      ventanaRepresentante: false,
      ventanaCertificado: false,
      emailVerificado: "",
      ventanaIAE: false,
      establecimientosGoogle: [],
      isMultiple: {
        SectorActividad: true,
        IAE: true,
        TipoBono: true,
      },
      masCampos: [
        // {
        //   texto: "Barrio",
        //   campo: "IdBarrio",
        //   tipo: "select",
        //   max: "160",
        //   obligatorio: true,
        //   visible: true,
        //   min: "2",
        //   multiple: false,
        //   valor: {},
        // },
      ],
      camposMultiples: [
        {
          texto: "Sector de actividad",
          campo: "SectorActividad",
          tipo: "select",
          obligatorio: false,
          visible: true,
          min: "1",
        },
        {
          texto: "IAE",
          campo: "IAE",
          tipo: "select",
          obligatorio: false,
          visible: true,
          min: "1",
        },
        {
          texto: "Tipo de Bonos",
          campo: "TipoBono",
          tipo: "select",
          obligatorio: false,
          visible: true,
          min: "1",
        },
      ],

      Aceptar: false,
      camposExtra: [
        {
          campo: "campo_extra_1",
          max: "100",
          min: "2",
          obligatorio: true,
          texto: "Representante Legal",
          tipo: "text",
          visible: true,
        },
        {
          campo: "campo_extra_2",
          max: "50",
          min: "2",
          obligatorio: true,
          texto: "DNI Representante Legal",
          tipo: "text",
          visible: true,
        },
      ],
      bonos: [
        {
          texto: "Tipo de Bonos",
          campo: "TipoBono",
          tipo: "select",
          max: "160",
          obligatorio: true,
          visible: true,
          min: "2",
        },
      ],
      imagenes: [
        {
          texto: "Imagen comercio",
          campo: "UrlImagen",
          tipo: "text",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Representante",
          campo: "UrlDni",
          tipo: "text",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Imagen Certificado",
          campo: "UrlCertificado",
          tipo: "text",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Imagen IAE",
          campo: "UrlIAE",
          tipo: "text",
          obligatorio: true,
          min: "2",
        },
      ],
      camposComprobar: [
        {
          texto: "NIF/CIF",
          campo: "CIF",
          tipo: "text",
          obligatorio: true,
          min: "6",
          max: "60",
          visible: true,
        },
        {
          texto: "E-mail",
          campo: "EMail",
          tipo: "email",
          max: "60",
          obligatorio: true,
          min: "2",
          visible: true,
        },
      ],
      formulario: [
        {
          texto: "Razón Social del establecimiento",
          campo: "RazonSocial",
          tipo: "text",
          max: "60",
          obligatorio: true,
          min: "2",
        },

        {
          texto: "Nombre Comercial",
          campo: "Nombre",
          tipo: "text",
          max: "60",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Sector de actividad",
          campo: "SectorActividad",
          tipo: "select",
          max: "60",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Breve descripción",
          campo: "Descripcion",
          tipo: "text",
          max: "128",
          obligatorio: true,
          min: "25",
        },
        {
          texto: "Nº de personas empleadas (incluído presonal autónomo)",
          campo: "NumeroEmpleados",
          tipo: "select",
          obligatorio: false,
          min: "1",
          max: "24",
        },
        {
          texto: "IAE",
          campo: "IAE",
          tipo: "select",
          obligatorio: false,
          min: "1",
        },
        {
          texto: "NIF/CIF",
          campo: "CIF",
          tipo: "text",
          obligatorio: true,
          min: "6",
          max: "60",
        },

        {
          texto: "Dirección",
          campo: "Direccion",
          tipo: "text",
          max: "120",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Código Postal",
          campo: "CP",
          tipo: "select",
          obligatorio: true,
          min: "5",
          max: "5",
        },
        {
          texto: "Municipio",
          campo: "Poblacion",
          tipo: "select",
          obligatorio: true,
          min: "9",
        },
        {
          texto: "Provincia",
          campo: "Provincia",
          tipo: "select",
          obligatorio: true,
          visible: true,
          min: "3",
        },
        {
          texto: "Persona de contacto",
          campo: "PersonaContacto",
          tipo: "text",
          obligatorio: true,
          max: "60",
          min: "2",
        },

        {
          texto: "Cargo",
          campo: "Cargo",
          tipo: "text",
          max: "60",
          obligatorio: true,
          min: "3",
        },
        {
          texto: "E-mail",
          campo: "EMail",
          tipo: "email",
          max: "60",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Verificar e-mail",
          campo: "VerifyEMail",
          tipo: "email",
          obligatorio: true,
        },
        {
          texto: "Teléfono",
          campo: "Telefono",
          tipo: "text",
          max: "60",
          obligatorio: true,
          min: "9",
        },

        {
          texto: "Página web",
          campo: "Web",
          tipo: "text",
          max: "180",
          obligatorio: false,
        },
        {
          texto: "Asociaciones de comerciantes a las que pertenece",
          campo: "NombreAsociacion",
          tipo: "text",
          max: "60",
          obligatorio: false,
          min: "5",
        },
        {
          texto: "IBAN",
          campo: "IBAN",
          tipo: "text",
          obligatorio: true,
          min: "24",
          max: "24",
        },
      ],
    };
  },
  // Nombre, Descripcion, Contacto, CIF, Telefono, IdGoogle, EMail, IBAN, DireccionGoogle, Lat, Lng, UrlImagen, Direccion, CP, Provincia, Poblacion, Pais

  computed: {
    campanasActivas() {
      const bonoActual = this.campanas[this.campanaDestino];
      const campanas = Object.keys(this.campanas);
      const resultado = {};

      if (bonoActual) {
        bonoActual.forEach((e) => (resultado[e.ID] = e));
      }

      // console.log('resulado', resultado, bonoActual)
      return resultado;
    },
    imgUrl() {
      return this.$store.state.img1;
    },
    SectorActividad: {
      get() {
        return this.$store.state.SectorActividad;
      },
      set(valor) {
        this.$store.commit("SectorActividad", valor);
      },
    },
    IAE: {
      get() {
        return this.$store.state.IAE;
      },
      set(valor) {
        this.$store.commit("IAE", valor);
      },
    },
    TipoBono: {
      get() {
        return this.$store.state.TipoBono;
      },
      set(valor) {
        this.$store.commit("TipoBono", valor);
      },
    },
    conDireccion() {
      let conDireccion = false;
      if (
        this.establecimientoActual.Nombre.length > 3 &&
        this.establecimientoActual.Direccion.length > 3
      ) {
        conDireccion = true;
        // this.checkDireccion(this.establecimientoActual);
      }

      return conDireccion;
    },
    camposVisibles() {
      return this.formulario.filter((e) => e.visible);
    },
    bonoActual() {
      const bonoActual = this.$store.state.bonoActual;
      this.formulario = !bonoActual.formulario ? [] : bonoActual.formulario;
      this.imagenes = !bonoActual.imagenes ? [] : bonoActual.imagenes;
      return bonoActual;
    },
    emailCorrecto() {
      if (
        this.establecimientoActual.EMail ==
        this.establecimientoActual.VerifyEMail
      ) {
        return true;
      } else {
        return false;
      }
    },
    conImagenes() {
      // this.UrlImagen &&
      if (this.UrlImagen && this.UrlIAE) {
        return true;
      } else {
        return false;
      }
    },
    validador() {
      let valido = false;
      const validados = {};
      const obligatorios = this.formulario.filter(
        (e) => e.visible == true && e.obligatorio == true
      );
      const todos = obligatorios.filter(
        (e) => !this.establecimientoActual[e.campo]
      );

      // console.log("todos", todos);

      return todos;
    },
    validador2() {
      return this.camposMultiples.filter((e) => this[e.campo].length < 1);
    },
    establecimientoActual: {
      get() {
        return this.$store.state.establecimientoActual;
      },
      set(valor) {
        this.$store.commit("establecimientoActual", valor);
      },
    },
    UrlImagen: {
      get() {
        return this.$store.state.UrlImagen;
      },
      set(valor) {
        this.$store.commit("UrlImagen", valor);
      },
    },
    UrlDni: {
      get() {
        return this.$store.state.UrlDni;
      },
      set(valor) {
        this.$store.commit("UrlDni", valor);
      },
    },
    UrlCertificado: {
      get() {
        return this.$store.state.UrlCertificado;
      },
      set(valor) {
        this.$store.commit("UrlCertificado", valor);
      },
    },
    UrlIAE: {
      get() {
        return this.$store.state.UrlIAE;
      },
      set(valor) {
        this.$store.commit("UrlIAE", valor);
      },
    },
    listado() {
      const bono = this.$store.state.bonoName;
      console.log("bono actual", bono);
      const IAE = this.$i18n.locale == "es" ? IAE_TURISMO : IAE_TURISMO_EU;
      const SectorActividad =
        this.$i18n.locale == "eu" ? SectorActividad_eu : SectorActividad_es;
      const Bonos = this.$i18n.locale == "eu" ? Bonos_eu : Bonos_es;
      const miMunicipio = Municipios[bono];
      const NumeroEmpleados = [
        {
          value: "",
        },
        {
          value: 1,
        },
        {
          value: 2,
        },
        {
          value: 3,
        },
        {
          value: 4,
        },
        {
          value: 5,
        },
        {
          value: 6,
        },
        {
          value: 7,
        },
        {
          value: 8,
        },
        {
          value: 9,
        },
        {
          value: 10,
        },
      ];
      console.log("bonos", Bonos);
      const ORIGEN = this.origenDestino;
      const id_CAMPANA = this.campanaDestino;
      const misBonos = Bonos.map((e) => {
        return {
          ORIGEN,
          id_CAMPANA,
          ...e,
        };
      });
      const listado = {
        Poblacion: miMunicipio,
        IAE: IAE,
        NumeroEmpleados,
        SectorActividad,
        TipoBono: misBonos,
      };
      return listado;
    },
    Id() {
      let random = Math.random().toString(36).substring(2);
      return random.toUpperCase();
    },
    validosBonos() {
      return this.TipoBono.map((e) => e.id_CAMPANA);
    },
    misBonos() {
      return this.TipoBono.map((e) => ({
        id_CAMPANA: e.id_CAMPANA,
        texto: e.label,
        SECTORACTIVIDAD: e["SECTORACTIVIDAD"],
        id_SECTOR: e.id_SECTOR,
        id_BONO: e.value,
      }));
    },
    validosIAE() {
      const misBonos = this.misBonos;
      const iaes = this.IAE.map((e) => e.id_CAMPANA);
      const validos = misBonos.filter((e) => iaes.indexOf(e.id_CAMPANA) < 0);

      return validos;
    },
    validosSector() {
      const misBonos = this.misBonos;
      const sectores = this.SectorActividad.map((e) => e.id_BONO);
      const validos = misBonos.filter((e) => sectores.indexOf(e.id_BONO) < 0);
      return validos;
    },
    camposValidados() {
      let validados = false;
      if (
        this.validador2.length < 1
        // this.validosSector.length < 1 &&
        // this.validosIAE.length < 1
        // this.UrlCertificado &&
        // this.establecimientoActual.IdBarrio
      ) {
        validados = true;
      } else {
        validados = false;
      }

      return validados;
    },
  },
  methods: {
    accionMasCampos(campo) {
      this.$nextTick(() => {
        this.establecimientoActual[campo.campo] = campo.valor.value;
        // console.log('cambio', campo, this.establecimientoActual)
      });
    },
    async cambiarCorto(valor) {
      const ID = valor.ID;
      const UrlCertificado = this.UrlCertificado;
      const IdBarrio = this.establecimientoActual.IdBarrio
        ? this.establecimientoActual.IdBarrio
        : "";

      const respuesta = await this.$store.dispatch("modificarCorto", {
        ID,
        UrlCertificado,
        IdBarrio,
      });

      if (respuesta.statusText == "OK") {
        this.$toast.info(this.$t("ADJUNTOS ENVIADOS"));
        // this.$toast.info(this.$t("Enviando Información"));
      } else {
        this.$toast.error(this.$t("ADJUNTOS NO ENVIADOS"));
      }

      // console.log('respuesta', respuesta)

      return respuesta;
    },
    getImagen(valor) {
      let imagen = valor.URLIMAGEN == "1" ? this.imgUrl : valor.URLIMAGEN;
      // console.log('hola', valor, imagen)
      return imagen;
    },
    async test() {
      let campanas = "";
      let iaes = "";
      let sectores = "";
      this.TipoBono.forEach(
        (e, i) =>
          (campanas += `${e.id_CAMPANA};${e.value}${
            i < this.TipoBono.length - 1 ? "-" : ""
          }`)
      );
      this.IAE.forEach(
        (e, i) => (iaes += `${e.value}${i < this.IAE.length - 1 ? "," : ""}`)
      );
      this.SectorActividad.forEach(
        (e, i) =>
          (sectores += `${e.value}${
            i < this.SectorActividad.length - 1 ? "," : ""
          }`)
      );
      const Peticion = `<Peticion IdOrigen = ${String(
        this.origenDestino
      )} CIF = "11111111" IdFormulario="f4tux" SectoresActividad ="${sectores}" CampanyasBonos="${campanas}" IAE="${iaes}" IdPaisINE="0" IdPoblacionINE="0" IdProvinciaINE="0" IdBarrio="18" Nombre="boutique loycar" RazonSocial="ASDFAFASDF" Descripcion="Esto es una TV local me gustaría que mas" SectorActividad ="0" NumeroEmpleados="1" PersonaContacto="Samuel" Cargo="direc" Contacto = "[{&quot;campo&quot;:&quot;campo_extra_1&quot;,&quot;max&quot;:&quot;100&quot;,&quot;min&quot;:&quot;2&quot;,&quot;obligatorio&quot;:true,&quot;texto&quot;:&quot;Representante Legal&quot;,&quot;tipo&quot;:&quot;text&quot;,&quot;visible&quot;:true},{&quot;campo&quot;:&quot;campo_extra_2&quot;,&quot;max&quot;:&quot;50&quot;,&quot;min&quot;:&quot;2&quot;,&quot;obligatorio&quot;:true,&quot;texto&quot;:&quot;DNI Representante Legal&quot;,&quot;tipo&quot;:&quot;text&quot;,&quot;visible&quot;:true}]" Telefono = "657871810" EMail = "samuel.ebuka@gmail.com" Web="www.google.es" NombreAsociacion="1" Direccion = "sabino arana 56" CP = "28270" Provincia = "BIZKAIA" Poblacion = "Alonsotegi" Pais = "España" IBAN = "ES6000491500051234567892" IdGoogle = "ChIJL50yLFBaTg0RKAas7VFi5TY" Lat = "43.3234795" Lng = "-2.9870257" DireccionGoogle = "Av. Sabino Arana Etorbidea, 56, 48940 Leioa, BI, España" UrlImagen = "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/establecimientos%2Fbizkaia%2Fbonogv%2FRJGXB5Y1RCH%2FfvRJGXB5Y1RCH%40_UrlImagen__imagen-comercio.jpg?alt=media&amp;token=0725b523-dd9c-4035-9b4d-a03aa854c4c9" UrlDni="1" UrlCertificado="1" UrlIAE="https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/establecimientos%2Fberriz%2Fbonogv%2FRJGXB5Y1RCH%2FfvRJGXB5Y1RCH%40_UrlIAE__fichero-iae.png?alt=media&amp;token=bb80631d-dada-4492-b61b-437d77004248" />`;
      // console.log('Peticion', Peticion, 'Campaña', campanas, 'iaes', iaes, 'sectores', sectores)

      const completaRes = await this.$store.dispatch("altaCompleta", Peticion);
      // console.log('RESPUESTA', completaRes)
    },
    async enviarCambios() {
      this.$toast.info(this.$t("Enviando Información"));
      const resCampana = await this.$store.dispatch("asignarCampana", {
        IdEstablecimiento: this.editarActual.ID,
        bonos: this.TipoBono,
      });

      // console.log('Sectores', SectorActividad_es, 'Bono', this.TipoBono, 'IAE', this.IAE, 'Sector', this.SectorActividad)
      const resTipoBono = await this.$store.dispatch("asignarBonos", {
        IdEstablecimiento: this.editarActual.ID,
        TipoBono: this.TipoBono,
      });
      // console.log('TipoBono', resTipoBono)

      const resIAE = await this.$store.dispatch("asignarIAE", {
        IdEstablecimiento: this.editarActual.ID,
        IAES: this.IAE,
      });
      // console.log('IAE', resIAE)

      const resSectorActividad = await this.$store.dispatch("asignarSectores", {
        IdEstablecimiento: this.editarActual.ID,
        SectorActividad: this.SectorActividad,
      });
      // console.log('SectorActividad', resSectorActividad)

      // this.resetear()
      this.$toast.clear();
      if (
        resCampana.statusText == "OK" &&
        resTipoBono.statusText == "OK" &&
        resIAE.statusText == "OK" &&
        resSectorActividad.statusText == "OK"
      ) {
        const slug = slugify(this.editarActual.NOMBRE, {
          lower: true,
          remove: /[*+~.·?¿^()/'"!:@]/g,
        });
        const idEstablecimiento = this.editarActual.ID;
        this.$store.commit("slug", `${idEstablecimiento}-${slug}`);
        // this.cambiarCorto(this.editarActual);
        this.$toast.success(this.$t("Envio Correcto"));
        this.$store.commit("idEstablecimientoActual", idEstablecimiento);
        this.$store.commit("bonoName", "bizkaia");

        this.resetear();
        this.$router.push(`/${this.$i18n.locale}/contenido/final/`);
      } else {
        this.$toast.error(this.$t("Error en el envio, inténtelo más tarde"));
      }
    },
    resetear() {
      this.mostrarFormulario = false;
      this.editarActual = {};
      this.$store.dispatch("resetFormulario");
    },
    accionCambio(valor) {
      this.$nextTick(() => {
        this.establecimientoActual[valor] = this[valor].map((e) => e.value);
      });
    },
    accionQuitar(valor) {
      this.$nextTick(() => {
        if (valor == "TipoBono") {
          this.IAE = [];
          this.SectorActividad = [];
          this.establecimientoActual.IAE = [];
          this.establecimientoActual.SectorActividad = [];
          // console.log("borrados", this.IAE, this.SectorActividad);
        }
        this.establecimientoActual[valor] = this[valor].map((e) => e.value);
      });
    },
    async accion() {
      const id = "180";

      return await this.$store.dispatch("asignarSectores", id);
      await this.$store.dispatch("asignarIAE", id);
      await this.$store.dispatch("asignarBonos", id);
    },
    async checkDireccion(sitio) {
      const google = await gmapsInit();
      const map = this.$refs.mapa;
      var service;

      var query = sitio.Nombre + " " + sitio.Direccion;

      var request = {
        query,
        fields: [
          "name",
          "geometry",
          "formatted_address",
          "id",
          "place_id",
          "icon",
          "types",
          "photos",
          "business_status",
        ],
      };
      // console.log('aqui 22',  query, google)
      service = new google.maps.places.PlacesService(map);
      service.findPlaceFromQuery(request, (results, status) => {
        // console.log('dentro', results, status, google)
        if (status == "OK") {
          const actual = results[0];
          this.establecimientosGoogle = results;
          this.establecimientoActual.IdGoogle = actual.place_id;
          this.establecimientoActual.DireccionGoogle = actual.formatted_address;
          this.establecimientoActual.Lat = String(
            actual.geometry.location.lat()
          );
          this.establecimientoActual.Lng = String(
            actual.geometry.location.lng()
          );

          var latLng = new google.maps.LatLng(
            actual.geometry.location.lat(),
            actual.geometry.location.lng()
          );
          var mapOptions = {
            zoom: 19,
            center: latLng,
          };
          const map2 = new google.maps.Map(this.$refs.mapa, mapOptions);
          var marker = new google.maps.Marker({
            position: latLng,
            map: map2,
            title: this.establecimientoActual.Nombre,
          });
        } else {
          // console.log('sin resultados')
        }
      });
    },
    log(valor) {
      // console.log('varl', valor)
      // this.nuevaImagen = valor
    },
    IBANCorrecto(valor) {
      return fn_ValidateIBAN(valor);
    },
    verLog(valor) {
      // cl*("ver log formulario", valor, "ver Datos", this.validador);
    },
    cerrarVentana(valor) {
      // cl*("cerrar ventana", valor);
      this[valor] = false;
    },
    imagenActual(valor) {
      return this;
    },
    async onSubmit({ target }) {
      const form = new FormData(target);
      const data = Object.fromEntries(form);
      const resultado = await this.$store.dispatch(
        "comprobarEstablecimiento",
        data
      );
      this.$toast.clear();

      if (resultado.hasOwnProperty("data")) {
        if (resultado.data.ESTABLECIMIENTOS_OBTENER.Respuesta == "OK") {
          if (resultado.data.ESTABLECIMIENTOS_OBTENER.Registros.Registro) {
            const registros = !Array.isArray(
              resultado.data.ESTABLECIMIENTOS_OBTENER.Registros.Registro
            )
              ? [resultado.data.ESTABLECIMIENTOS_OBTENER.Registros.Registro]
              : resultado.data.ESTABLECIMIENTOS_OBTENER.Registros.Registro;
            const campanas = {};
            const filtro = registros.filter(
              // (f) => f.PROVINCIA
              (f) => f.PROVINCIA.toUpperCase() == "BIZKAIA"
            );
            const validos = filtro.filter(
              (s) => s.IDORIGEN == this.origenFiltro
            );
            filtro.forEach((e) => {
              if (!campanas.hasOwnProperty(e.IDORIGEN)) {
                campanas[e.IDORIGEN] = [];
              }
              campanas[e.IDORIGEN].push(e);
            });
            const existeCampana = filtro.find(
              (o) => o.IDORIGEN == this.origenDestino
            );
            const existeCorreo = registros.find(
              (e) => e.EMAIL.toLowerCase() == data.EMail.toLowerCase()
            );
            // const existenCorreos = registros.filter((e) => e.EMAIL == data.EMail);

            // const repetido = existeCampana ? existeCampana : {}
            console.log("mira", existeCampana, validos);
            if (validos.length < 1 && existeCorreo) {
              this.$toast.info(
                this.$t("NO SE ENCUENTRAN ESTABLECIMIENTOS VALIDOS")
              );
            } else if (existeCorreo && existeCampana) {
              this.$toast.info(this.$t("YA EXISTE EN CAMPAÑA"));
            } else if (existeCorreo && validos.length > 0) {
              this.$toast.success(this.$t("Acceso correcto"));
              this.campanas = campanas;
              this.mostrarFormulario = false;
              this.editarActual = existeCorreo;
              if (existeCampana) {
                // this.$toast.warning(this.$t("ESTABLECIMIENTOS VALIDOS"));
              }
              // console.log("existeCorreo", existeCorreo);
            } else {
              this.$toast.error(this.$t("Datos Incorrectos"));
              this.establecimientoActual["EMail"] = "";
            }
          } else {
            this.$toast.error(this.$t("No Existe"));
          }

          // const registros = !Array.isArray(resultado.data.ESTABLECIMIENTOS_OBTENER.Registros.Registro) ? [resultado.data.ESTABLECIMIENTOS_OBTENER.Registros.Registro] : resultado.data.ESTABLECIMIENTOS_OBTENER.Registros.Registro

          // registros.forEach(async registro=>{
          //   const ID = registro.ID
          //   const IDORIGEN = registro.IDORIGEN
          //   const accion = await this.$store.dispatch('consultarCompleto', {ID, IDORIGEN})

          /// console.log('datos', resultado.data.ESTABLECIMIENTOS_OBTENER, 'accion', accion)
          // })
        } else {
          // console.log("miras", resultado);
          this.$toast.error(this.$t("Error de Conexión, inténtalo más tarde"));
        }
      }
      // const objeto = this.establecimientoActual;

      // Object.keys(objeto).forEach((campo) => {
      //   if (!Array.isArray(objeto[campo])) {
      //     objeto[campo] = objeto[campo]
      //       .replace(/&/g, "&amp;")
      //       .replace(/>/g, "&gt;")
      //       .replace(/</g, "&lt;")
      //       .replace(/"/g, "&quot;");
      //   } else {
      //   }
      // });

      // console.log("form", form, "data", data);
    },
    async comprobarCompleto(valor) {
      const miEstablecimiento = !this.campanasActivas[valor.ID]
        ? valor
        : this.campanasActivas[valor.ID];
      const { ID, IDORIGEN } = miEstablecimiento;
      const datosCompleto = await this.$store.dispatch("consultarCompleto", {
        ID,
        IDORIGEN,
      });
      this.editable =
        miEstablecimiento.IDORIGEN != this.origenDestino ? true : false;
      // console.log('existe', datosCompleto, miEstablecimiento, this.campanasActivas)
      if (datosCompleto.hasOwnProperty("data")) {
        if (
          datosCompleto.data.ESTABLECIMIENTO_OBTENERDATOS_COMPLETO.Respuesta ==
          "OK"
        ) {
          const actual =
            datosCompleto.data.ESTABLECIMIENTO_OBTENERDATOS_COMPLETO.RetornoXml
              .Establecimiento;
          const establecimiento =
            datosCompleto.data.ESTABLECIMIENTO_OBTENERDATOS_COMPLETO.RetornoXml
              .Establecimiento.DatosEstablecimiento;

          establecimiento.IAES = Array.isArray(actual.IAES.IAE)
            ? actual.IAES.IAE
            : [actual.IAES.IAE];
          establecimiento.SECTORES = Array.isArray(actual.Sectores.Sector)
            ? actual.Sectores.Sector
            : [actual.Sectores.Sector];
          establecimiento.BONOS = Array.isArray(actual.Bonos.Bono)
            ? actual.Bonos.Bono
            : [actual.Bonos.Bono];
          establecimiento.CAMPANYA = Array.isArray(actual.Campanyas.Campanya)
            ? actual.Campanyas.Campanya
            : [actual.Campanyas.Campanya];

          this.editarActual = establecimiento;

          this.datosCompleto = establecimiento;
          var element = this.$refs["ficha"];
          // console.log(element);
          var top = element.offsetTop;
          window.scrollTo({
            top: top,
            left: 0,
            behavior: "smooth",
          });
        }
      } else {
        this.$toast.error(this.$t("Error de conexión"));
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.vts-input {
  margin-bottom: 1rem;
}
.obligatorio .vts-input__text:after {
  content: "*";
  speak: none;
  color: red;
}
.vts-input__input {
  display: block;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 8px;
  overflow-x: auto;
}
.condiciones .vts-input--checkbox label {
  display: flex;
}

.vts-input--checkbox .vts-input__input {
  width: 20px;
}
.vts-input--error .vts-input__input {
  border-color: red;
}
.vts-input__description small {
  color: red;
}

.vts-form input {
  width: 100%;
}
.vts-form input,
.vts-form button {
  border-radius: 5px;
  padding: 0.5rem;
}

.vts-form input {
  border: 1px solid #e2e8f0;
}

.vts-form button {
  border: 0;
}

/* .vts-form:not(.vts-form--invalid) button {
  color: #fff;
  background: seagreen;
} */

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* margin: 0; */
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>

